import { AdminCronRunResult } from "../models/admin-cron.models";
import { OnboardingCertificateCandidate } from "../models/onboarding-certificate-candidates-table.models";
import type { TechFormInboxJsonPreview } from "../models/admin-monitoring.models";

// Makes the failed operation visible beside the reason, including evidence that the attachment was downloaded.
export const getTechFormInboxAttachmentDiagnosticSummary = (result: TechFormInboxJsonPreview): string => {
  let stageLabel: string | undefined;

  switch (result.stage) {
    case "downloadAttachment":
      stageLabel = "Attachment download";
      break;
    case "readAttachmentContent":
      stageLabel = "Attachment content";
      break;
    case "parseAttachmentJson":
      stageLabel = "JSON parsing";
      break;
    case "validateTechFormPayload":
      stageLabel = "Tech Form validation";
      break;
    case "correlateTechFormInboxJson":
      stageLabel = "Snowflake verification";
      break;
    default:
      stageLabel = result.stage;
  }

  return [
    stageLabel ? `Failure stage: ${stageLabel}` : "",
    result.httpStatus !== undefined ? `HTTP ${result.httpStatus}` : "",
    result.downloadedBytes !== undefined ? `Downloaded: ${result.downloadedBytes} bytes` : "",
    result.stage === "downloadAttachment" ? "No attachment content received" : "",
    result.contentType ? `Attachment type: ${result.contentType}` : "",
  ]
    .filter(Boolean)
    .join(" · ");
};

export const getVesselCandidateRows = (result: AdminCronRunResult): OnboardingCertificateCandidate[] => {
  const details = (result.data as { details?: { vesselsToRequest?: unknown } } | undefined)?.details;
  const rows = details?.vesselsToRequest;

  if (!Array.isArray(rows)) {
    return [];
  }

  return rows.filter((row): row is OnboardingCertificateCandidate => typeof row === "object" && row !== null);
};
